import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../club-api-client";
import type { CreateExclusionDates } from "../../types";
import { queryKeys } from "../query-keys";

export function useExclusionDates(clubId: string | null, seasonId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.trainingExclusionDates(clubId ?? "", seasonId ?? ""),
		queryFn: () => clubApi.training.exclusionDates.list(clubId!, seasonId!),
		enabled: !!clubId && !!seasonId,
	});
}

export function useCreateExclusionDates(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ seasonId, data }: { seasonId: string; data: CreateExclusionDates }) =>
			clubApi.training.exclusionDates.create(clubId, seasonId, data),
		onSuccess: () =>
			qc.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "training"],
			}),
	});
}

export function useDeleteExclusionDate(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ seasonId, dateId }: { seasonId: string; dateId: string }) =>
			clubApi.training.exclusionDates.delete(clubId, seasonId, dateId),
		onSuccess: () =>
			qc.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "training"],
			}),
	});
}
